export default __webpack_public_path__ + "static/media/n_btn.fb738122.svg";